import React from 'react';
import { func } from 'prop-types';
import { UTButton } from '@widergy/energy-ui';

import { formResponsePropTypes } from 'redux/userFormHandlers';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';
import { CANCELATION, REITERATION } from 'constants/userForms';

import stylesJS from './styles';
import styles from './styles.module.scss';

function ActionClaims({ rowData, handleOpenActionModal }) {
  return (
    <div style={stylesJS.rowButtonContainer}>
      {rowData.cancellable && rowData.status.isPending && (
        <UTButton
          className={!appConfig.claims.openableRow && styles.rowButton}
          onPress={() => handleOpenActionModal(rowData.id, CANCELATION, rowData.form_name)}
        >
          {message('Commons:cancel')}
        </UTButton>
      )}
      {rowData.reiterable && rowData.status.isPending && rowData.external_id && (
        <UTButton
          className={!appConfig.claims.openableRow && styles.rowButton}
          onPress={() => handleOpenActionModal(rowData.id, REITERATION, rowData.form_name)}
        >
          {message('FieldDetails:reiterate')}
        </UTButton>
      )}
    </div>
  );
}

ActionClaims.propTypes = {
  rowData: formResponsePropTypes,
  handleOpenActionModal: func
};

export default ActionClaims;
